import { render, staticRenderFns } from "./PATsByStatus.vue?vue&type=template&id=3c746780&scoped=true"
import script from "./PATsByStatus.vue?vue&type=script&lang=js"
export * from "./PATsByStatus.vue?vue&type=script&lang=js"
import style0 from "./PATsByStatus.vue?vue&type=style&index=0&id=3c746780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c746780",
  null
  
)

export default component.exports